export default __webpack_public_path__ + "static/media/img4.01d9f9d1.png";